<div class="table-fields" *ngIf="this.dataSource != null">
  <div *ngIf="this.tableConfiguration != null && this.columns != null">
    <ng-container *ngIf="mode == GritDynamicTableMode.SELECT_ONE">
      <label class="full">Select 1 {{ entityName }}</label>
    </ng-container>

    <ng-container *ngIf="mode == GritDynamicTableMode.SELECT_MULTIPLE">
      <label class="full">Select at least 1 {{ entityName }}</label>
    </ng-container>

    <div style="max-height: 325px; overflow: auto">
      <table mat-table [dataSource]="rows">
        <ng-container matColumnDef="selected" *ngIf="mode > GritDynamicTableMode.SELECT">
          <th mat-header-cell *matHeaderCellDef>
            <ng-container *ngIf="mode == GritDynamicTableMode.SELECT_MULTIPLE">
              <input type="checkbox" [(ngModel)]="isAllSelected"/>
            </ng-container>
          </th>
          <td mat-cell *matCellDef="let row">
            <input type="checkbox" [(ngModel)]="row.selected" (click)="selectFeature(row)"/>
          </td>
        </ng-container>

        <ng-container *ngFor="let column of tableConfiguration; let i = index;" [matColumnDef]="column.display" >
          <th mat-header-cell *matHeaderCellDef> {{column.display}} </th>
          <td mat-cell *matCellDef="let row"> {{ column.value.fieldValue(row.model)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true" style="height: fit-content"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" (click)="selectRow(row)"
            style="height: fit-content;"
            [style.cursor]="mode == GritDynamicTableMode.SELECT ? 'pointer' : 'default'"
            [class.highlighted]="mode == GritDynamicTableMode.SELECT && row == this.selectedRow"></tr>
      </table>
    </div>
    <mat-paginator
      [length]="dataSource.length"
      [pageSize]="pageSize"
      (page)="pageEvent($event)">
    </mat-paginator>
  </div>
</div>
